import { FormControlLabel, RadioGroup, Radio, Typography } from '@material-ui/core';
import React from 'react';
import { AddOnSmileDesignQuestion } from '../type';
import { useDispatch, useSelector } from 'react-redux';
import { useLang } from '../../../../util/lang';
import { BASE_PRESCRIPTION_NOTES_LANG_KEY } from '../RestorativeOptions/RestorativeOptions';
import {
    NEW_PATIENT_ADD_ON_SMILE_DESIGN,
    NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_DATA,
    NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_IS_VALID,
} from '../../../../store/NewPatient/actionType';

/**
 * RestorativeOptions component for displaying restorative treatment options
 * @param {Object} props - Component props
 * @param {AddOnSmileDesignQuestion} props.question - The question object containing restorative options
 * @param {boolean} props.readOnly - Whether the component is in read-only mode
 */
const AddOnSmileDesign = (props) => {
    const getNotes = useLang(`NewPatient`);
    const newPatientReducer = useSelector((store) => store.newPatientReducer);
    const { addOnSmileDesign } = newPatientReducer;
    const dispatch = useDispatch();
    const { readOnly, question } = props;
    return (
        <>
            <span>{getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.addOnSmileDesign`)}</span>
            <br />
            <span style={{ paddingLeft: 30 }}>{getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.additionalFee`)}</span>
            <RadioGroup value={addOnSmileDesign?.value}>
                {question.options.map((opt, idx) => {
                    return (
                        <FormControlLabel
                            value={opt.value}
                            key={opt.value + idx.toString()}
                            control={<Radio />}
                            label={opt.label}
                            onChange={(e) => {
                                if (readOnly) return;
                                dispatch({ type: NEW_PATIENT_ADD_ON_SMILE_DESIGN, value: e.target.value });
                                let isValid = true;
                                if (e.target.value === 'Yes') {
                                    isValid = false;
                                } else {
                                    // reset the smile design prescription form data when user select No
                                    dispatch({
                                        type: NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_DATA,
                                        value: {},
                                    });
                                }
                                dispatch({
                                    type: NEW_PATIENT_SET_UPSELL_SMILE_DESIGN_PRESCRIPTION_FORM_IS_VALID,
                                    value: isValid,
                                });
                            }}
                        />
                    );
                })}
                {addOnSmileDesign?.value === 'Yes' && !readOnly && (
                    <Typography style={{ marginLeft: 32, color: 'red', fontWeight: 'bold' }}>
                        {getNotes(`${BASE_PRESCRIPTION_NOTES_LANG_KEY}.fillSmileDesignForm`)}
                    </Typography>
                )}
            </RadioGroup>
        </>
    );
};

export default AddOnSmileDesign;
